import styled, { css } from 'styled-components';

import {
  INPUT_BORDER_WIDTH,
  INPUT_HEIGHT,
  INPUT_MARGIN_BOTTOM,
  INPUT_PADDING_HORIZONTAL,
} from '@front/common/src/components/input/styles';
import type { InputColors } from '@front/common/src/components/input/types';
import colors, { withOpacity } from '@front/common/src/utils/colors';

import { MIN_MD } from '../../../constants/breakpoints';
import { borderGradient50, borderGradient100 } from '../../../styles/gradient';
import { type TextStyleProps, textStyle } from '../../base-text/base-text';

// @ts-ignore TODO: fix typing
export const Container = styled.div.attrs({ 'data-testid': 'container' })<{ $isDisabled: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: ${INPUT_MARGIN_BOTTOM}px;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.5 : 1)};
`;

type InputFrameProps = {
  $inputId: string;
  $hasHoverStyle: boolean;
  $inputColors: InputColors;
};

export const InputFrame = styled.label.attrs<InputFrameProps>(({ $inputId }) => ({
  htmlFor: $inputId,
  'data-testid': 'input-frame',
}))<InputFrameProps>`
  position: relative;
  display: flex;
  flex-direction: row;
  border-radius: 8px;

  ${({ $inputColors }) => `
    border: ${INPUT_BORDER_WIDTH}px solid ${$inputColors.border === 'gradient' ? 'transparent' : $inputColors.border};
    background: ${$inputColors.border === 'gradient' ? borderGradient100 : $inputColors.background};
  `}

  ${({ $hasHoverStyle }) =>
    $hasHoverStyle &&
    `
    @media (min-width: ${MIN_MD}) {
      &:hover {
        border-color: transparent;
        background: ${borderGradient50};
      }
    }
  `}
`;

// Relative element to position <AnimatedPlaceholder /> correctly
export const InputContainer = styled.div`
  position: relative;
  flex-grow: 1;
  padding: 0 ${INPUT_PADDING_HORIZONTAL}px;
`;

// Removes background color applied on inputs by the browser when using the browser autocomplete.
const chromeAutocompleteStyleReset = css`
  &:-webkit-autofill {
    -webkit-background-clip: text; /* stylelint-disable-line property-no-vendor-prefix */
    -webkit-text-fill-color: ${colors.ink100} !important;
  }
`;

export type InputStyleProps = TextStyleProps & {
  $hasLabel: boolean;
  $isFocused: boolean;
};

export const baseInputStyle = css<InputStyleProps>`
  ${textStyle}
  font-weight: 500;
  ${chromeAutocompleteStyleReset}
  min-height: ${INPUT_HEIGHT - 2 * INPUT_BORDER_WIDTH}px;
  width: 100%;
  box-sizing: border-box;
  ${({ $hasLabel }) => $hasLabel && 'padding-top: 13px;'}

  ${({ $isFocused }) => `
    &::placeholder {
      color: ${$isFocused ? withOpacity(colors.ink100, 0.7) : 'transparent'};
    }
  `}
`;
